export default {"src":"/_next/static/media/lead-credo.d5add021.svg","height":48,"width":416};